import Vue from 'vue'
import Router from 'vue-router'

import Viewport from '@/components/global/Viewport'
import CustomFieldForm from '@/components/customFields/CustomFieldForm'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import AssetDetails from '@/views/assets/AssetDetails'
import Assets from '@/views/managers/Assets'
import AssetMap from '@/views/maps/AssetMap'
import ManageGeoZonesMap from '@/views/maps/ManageGeoZonesMap'
import AssetOverview from '@/views/assets/AssetOverview.vue'
import Users from '@/views/managers/Users';
import UserRoles from '@/views/managers/UserRoles';
import AssetGroups from '@/views/managers/AssetGroups'
import AssetTypes from '@/views/managers/AssetTypes.vue'
import UnitTypes from '@/views/managers/UnitTypes.vue'
import GeoZoneTypes from '@/views/managers/GeoZoneTypes.vue'
import CustomFields from '@/views/managers/CustomFields.vue'
import MyProfile from '@/views/MyProfile.vue'
import TimeTables from '@/views/managers/TimeTables.vue'
import PoiOverview from '@/views/poi/PoiOverview'
import PoiDetails from '@/views/poi/PoiDetails'
import ReportMenu from '@/views/reports/ReportMenu'
import ReportWidget from '@/views/reports/ReportWidget'
import NotificationCenter from '@/views/notifications/NotificationCenter'
import Albatros from '@/views/debug/Albatros'

import test from '@/views/Test.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/login', name: 'Login', component: Login},
    { path: '/reset-password', name: 'ResetPassword', component: ResetPassword},    
    { path: '/', name: 'Viewport', component: Viewport, children: [
        { path: '/home', name: 'Home', component: Home, meta:{permission:'ui_home'}},
        { path: '/settings/asset-groups', name: 'AssetGroups', component: AssetGroups, meta:{permission:'ui_asset_groups'}},
        { path: '/settings/asset-types', name: 'AssetTypes', component: AssetTypes, meta:{permission:'ui_asset_types'}},
        { path: '/test', name: 'test', component: test},
        { path: '/asset-details/:assetId', name: 'AssetDetails', component: AssetDetails, meta:{permission:'ui_asset_details'}},
        { path: '/poi-details/:geoZoneId', name: 'PoiDetails', component: PoiDetails, meta:{permission:'ui_poi_details'}},
        { path: '/assets/map', name: 'AssetMap', props: { hideBreadcrumb:true }, component: AssetMap, meta:{permission:'ui_asset_map'}},
        { path: '/assets/overview', name: 'AssetOverview', component: AssetOverview, meta:{permission:'ui_asset_overview'}},        
        { path: '/reports', name: 'ReportMenu', component: ReportMenu, meta:{permission:'ui_reports'}},
        { path: '/reports/deployment', name: 'DeploymentReport', component: ReportWidget, meta:{permission:'ui_reports'}},
        { path: '/locations/overview', name: 'PoiOverview', component: PoiOverview, meta:{permission:'ui_location_overview'}},        
        { path: '/notifications' , name:'NotificationCenter', component: NotificationCenter, meta:{permission:'ui_notifications'}},
        { path: 'settings/geozones', name:'ManageGeoZonesMap', component:ManageGeoZonesMap, meta:{permission:'ui_geo_zone_manager'}},
        { path: 'settings/geo-zone-types', name:'ManageGeoZoneTypes', component:GeoZoneTypes, meta:{permission:'ui_geo_zone_type_manager'}},        
        { path: 'settings/users', name:'Users', component:Users, meta:{permission:'ui_user_manager'}},
        { path: 'settings/user-roles', name:'UserRoles', component:UserRoles, meta:{permission:'ui_user_roles'}},        
        { path: 'settings/unit-types', name:'UnitTypes', component:UnitTypes, meta:{permission:'ui_unit_type_manager'}},
        { path: 'settings/assets', name:'Assets', component:Assets, meta:{permission:'ui_asset_manager'}},
        { path: 'settings/custom-fields', name:'CustomFields', component:CustomFields, meta:{permission:'ui_custom_field_manager'}},
        { path: 'settings/time-tables' , name:'TimeTables', component:TimeTables, meta:{permission:'ui_time_table_manager'}},        
        { path: 'debug/albatros' , name:'AlbatrosDebug', component:Albatros, meta:{permission:'ui_albatros_debug'}},        
        { path: 'my-profile', name:'MyProfile', component:MyProfile},        
      ]
    }
  ]
})


//export default router
